import React from 'react';

export default function Suggestions({ suggestions, onSelect }) {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 mt-2 ml-8">
      {suggestions.map((suggestion, index) => (
        <button
          key={index}
          onClick={() => onSelect(suggestion)}
          className="px-4 py-2 min-h-[44px] rounded-full border-2 border-ia text-ia hover:bg-ia hover:text-white transition-colors"
        >
          {suggestion}
        </button>
      ))}
    </div>
  );
}
